// extracted by mini-css-extract-plugin
export default {"root":"classes_root__Fiwb9","mid-container":"classes_mid-container__bhX+X","icon":"classes_icon__IuT4M","icon-delete":"classes_icon-delete__nFE-s"};